<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <tissue-field-form-groups
        :submission="submission_data"
        :index="index"
        @onFieldChange="onFieldChange"
      ></tissue-field-form-groups>
      <hr />
      <tissue-crop-form-groups
        :submission="submission_data"
        :index="index"
        :cropOptions="cropOptions"
        :cropStageOptions="cropStageOptions"
        @onCropChange="onCropChange"
      ></tissue-crop-form-groups>
      <div v-if="submission_data.samples && submission_data.samples.length">
        <hr />
        <div
          v-for="(sample, sampleIndex) in submission_data.samples"
          :index="sampleIndex"
          :key="sampleIndex"
        >
          <add-on-select
            :selectedAddOns="sample.add_ons"
            :addOns="addOns"
            @onAddOnSelect="onAddOnSelect($event, sample)"
          ></add-on-select>
        </div>
      </div>
      <div v-if="turnArounds && turnArounds.models.length">
        <hr />
        <turn-around-select
          :turnArounds="turnArounds"
          :selectedTurnAround="submission_data.turnaround"
          @onTurnAroundSelect="onTurnAroundSelect"
        ></turn-around-select>
      </div>
      <hr />
      <b-button variant="danger" block @click="removeSubmission"
        ><i class="fal fa-trash"></i
      ></b-button>
    </b-card>
  </div>
</template>

<script>
import TissueFieldFormGroups from "./TissueFieldFormGroups";
import TissueCropFormGroups from "./TissueCropFormGroups";
import TurnAroundSelect from "../../TurnAroundSelect";
import AddOnSelect from "../../AddOnSelect";

export default {
  name: "TissueForm",
  components: {
    AddOnSelect,
    TissueCropFormGroups,
    TissueFieldFormGroups,
    TurnAroundSelect
  },
  props: [
    "addOns",
    "cropOptions",
    "cropStageOptions",
    "serviceQuestions",
    "submission",
    "index",
    "testPackageSamples",
    "turnArounds"
  ],
  data() {
    return {
      submission_data: null
    };
  },
  computed: {},
  methods: {
    onFieldChange(data) {
      if (data) {
        this.submission_data.identifier = data.identifier;
        this.submission_data.event_code = data.event_code;
        this.emitSubmissionChange();
      }
    },
    onCropChange(data) {
      if (data) {
        this.submission_data.submission_tissue.crop = data.crop;
        this.submission_data.submission_tissue.cropstage = data.cropstage;
        this.emitSubmissionChange();
      }
    },
    onTurnAroundSelect(turnaround) {
      if (turnaround && turnaround.id) {
        this.submission_data.turnaround = turnaround;
        this.submission_data.turnaround_id = turnaround.id;
        this.emitSubmissionChange();
      } else {
        this.submission_data.turnaround = null;
        this.submission_data.turnaround_id = null;
        this.emitSubmissionChange();
      }
    },
    emitSubmissionChange() {
      this.$emit("onSubmissionChange", {
        submission: this.submission_data,
        index: this.index
      });
    },
    removeSubmission() {
      this.$emit("removeSubmission", this.index);
    },
    onAddOnSelect(addOns, sample) {
      if (this.submission_data.samples && this.submission_data.samples.length) {
        this.submission_data.samples.forEach((inst, index) => {
          if (inst && inst.id === sample.id) {
            this.submission_data.samples[index]["add_ons"] = addOns;
            this.emitSubmissionChange();
          }
        });
      }
    }
  },
  watch: {
    form: {
      handler() {
        this.emitSubmissionChange();
      },
      deep: true
    },
    submission: {
      handler(value) {
        this.submission_data = value;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.submission) {
      this.submission_data = this.submission;
    }
  }
};
</script>
